// src/app/features/post/postSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postService } from "./postService";

export const getAllPosts = createAsyncThunk(
  "post/get",
  async (_, thunkAPI) => {
    try {
      return await postService.getPosts();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || error.message
      );
    }
  }
);

const initialState = {
  posts: [],

  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllPosts.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(getAllPosts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;

        // ✅ supports multiple backend shapes:
        // - array directly
        // - { posts: [...] }
        // - { post: [...] }
        const data = action.payload;
        state.posts = Array.isArray(data)
          ? data
          : data?.posts || data?.post || [];
      })
      .addCase(getAllPosts.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload || action.error.message;
      });
  },
});

export default postSlice.reducer;
